export var RMDETAILSRATING = "RMDETAILSRATING";
